<template>
    <form class="form">
        <div>사용자 확인을 위해 견적신청시 작성한 정보를 입력해주세요.</div>
        <div>
            <div><label>이름</label></div>
            <div>
                <input v-model="value.name" type="text" name="name" id="name" />
            </div>
        </div>
        <div>
            <div><label>연락처</label></div>
            <div>
                <input v-model="value.phone1" type="text" name="phone1" maxlength="4" id="phone1" /> - <input v-model="value.phone2" type="text" name="phone2" maxlength="4" id="phone2" /> -
                <input v-model="value.phone3" type="text" name="phone3" maxlength="4" id="phone3" />
            </div>
        </div>
        <div class="buttons">
            <input type="button" value="확인" @click="validate" />
        </div>
    </form>
</template>
<script>
export default {
    props: {
        value: {
            name: { type: String, default: null },
            phone1: { type: String, default: null },
            phone2: { type: String, default: null },
            phone3: { type: String, default: null },
        },
    },
    methods: {
        validate(event) {
            event.preventDefault()
            try {
                for (const key in this.value) {
                    if (!this.value[key]?.length) throw new Error(this.findError(key));
                }
                this.$emit("clickConfirm");
            } catch (error) {
                this.handleError(error);
            }
        },
        findError(key) {
            switch (key) {
                case "name":
                    return "이름이 잘못 입력되었습니다.";
                case "phone1":
                case "phone2":
                case "phone3":
                    return "연락처가 잘못 입력되었습니다.";
            }
        },
        handleError(error) {
            console.log(error);
            alert(error.response ? error.response.data.message : error.message);
        },
    },
};
</script>
<style lang="scss" scoped>
.form {
    > div:first-child {
        margin-bottom: 2rem;
        text-align: center;
        font-size: 1.4rem;
    }
    > div:not(:first-child) {
        margin: 1rem auto 0;
        width: 35rem;
    }
    > div > div {
        display: inline-block;
    }
    > div > div > label {
        display: inline-block;
        width: 4rem;
    }
    > div > div > input {
        width: 8rem;
        &:not(:last-child) {
            margin-right: 1rem;
        }
        &:not(:first-child) {
            margin-left: 1rem;
        }
    }

    .buttons {
        display: flex;
        justify-content: center;
        margin-top: 3rem !important;

        > input {
            padding: 0.7rem 2.1rem;
            font-size: 1.4rem;
        }
    }
}
</style>
